import React from "react";
import classes from "./GalleryPage.css";
import Book from "../../components/Book/Book";

import image2024_00 from "../../assets/images/gallery/2024-image00.jpg";
import image2024_01 from "../../assets/images/gallery/2024-image01.jpg";
import image2024_02 from "../../assets/images/gallery/2024-image02.jpg";
import image2024_03 from "../../assets/images/gallery/2024-image03.jpg";
import image2024_04 from "../../assets/images/gallery/2024-image04.jpg";

import image02 from "../../assets/images/gallery/02.jpg";
import image03 from "../../assets/images/gallery/03.jpg";
import image04 from "../../assets/images/gallery/04.jpg";
import image05 from "../../assets/images/gallery/05.jpg";
import image06 from "../../assets/images/gallery/06.jpg";
import image07 from "../../assets/images/gallery/07.jpg";
import image08 from "../../assets/images/gallery/08.jpg";
import image09 from "../../assets/images/gallery/09.jpg";
import image10 from "../../assets/images/gallery/10.jpg";
import image11 from "../../assets/images/gallery/11.jpg";

const gallerypage = (props) => (
    <div className={classes.Gallery}>
        <img src={image2024_00} alt="" />
        {/* <img src={image2024_01} alt="" /> */}
        <img src={image2024_02} alt="" />
        <img src={image2024_03} alt="" />
        <img src={image2024_04} alt="" />
        {/* <img src={image02} alt="" /> */}

        <img src={image04} alt="" />
        {/* <img src={image05} alt="" /> */}
        <img src={image06} alt="" />
        {/* <img src={image07} alt="" /> */}
        <img src={image08} alt="" />
        <img src={image09} alt="" />
        <img src={image10} alt="" />
        <img src={image11} alt="" />
        {/* <img src={image03} alt="" /> */}
        <Book />
    </div>
);

export default gallerypage;



// WEBPACK FOOTER //
// ./src/containers/GalleryPage/GalleryPage.js